/** Shared Dash-style left nav link classes. */
export function sidebarNavClass({ isActive }) {
  return [
    'mb-0.5 block border-l-[3px] border-transparent py-2 text-sm font-medium transition-colors',
    'pl-[calc(0.75rem-3px)] pr-3',
    isActive
      ? 'border-white bg-white/12 font-semibold text-white'
      : 'text-sidebar-foreground/70 hover:bg-white/8 hover:text-white',
  ].join(' ')
}
